<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="bg-primary">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/logo_login.png" alt="login" class="mx-auto" width="400" heigth="230">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-12">
                                <div class="vx-card__title mb-8 ">
                                    <p>&nbsp;</p>

                                    <h4 class="lg:w-1/2">Login</h4>

                                    <p>&nbsp;</p>

                                    <span v-if="badCredentials" style="color: red">{{badCredentialsMessage}}</span>

                                    <p>&nbsp;</p>
                                </div>
                                <vs-input
                                    id="user-input"
                                    v-validate="'required'"
                                    :danger="emailInput"
                                    danger-text="Email Invalido"
                                    name="user"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label="Utilizador"
                                    v-model="user"
                                    class="w-full no-icon-border"
                                />

                                <span class="text-danger text-sm" v-show="errors.has('user')">{{ errors.first('user') }}</span>
                                    <p>&nbsp;</p>
                                <vs-input
                                    id="pass-input"
                                    v-validate="'required'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label="Password"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" 
                                />

                                <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>

                                
                                <div class="flex flex-wrap justify-between my-5">
                                </div>

                                <div class="social-login flex flex-wrap justify-between">
                                    <div class="social-login-buttons flex flex-wrap items-center mt-4" >
                                    
                                        <vs-button class="float-left" @click="toLogin(user,password)" @keyup.enter.native="toLogin(user, password)">Login</vs-button>

                                    </div>

                                </div>
                                <p>&nbsp;</p>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import themeConfig from '@/../themeConfig.js';

import axios from 'axios';  

import moment from 'moment';

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    user: { 
      required: 'Campo Obrigatório',
      email: "Email não valido"
    },
    password: {
      required: 'Campo Obrigatório',
    },
  }
};
Validator.localize('pt', dict);

export default {
    data() {
        return {
            user: '',
            password: '',
            checkbox_remember_me: false,
            sucessLogin: false,
            emailInput: false,
            badCredentials: false,
            flag_login: true,
            badCredentialsMessage: 'Credenciais inválidas!! Tente de novo',
        }
    },  
    
    methods: {
        toLogin (user, pass) {
            if(!this.flag_login) {
                return;
            }
            this.flag_login = false;
            let that = this;        

            this.$validator.validateAll().then(result => {
                if (result){                
                    this.$vs.loading();
                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/auth/loginInternal',
                        data: {
                            login: user,
                            password: pass,
                            noEncrypted: true
                        },
                        headers: {
                            Authorization: 'Bearer '+process.env.VUE_APP_TOKEN
                        }
                    })
                    .then(function (response) {
                        that.badCredentials = false;
                        
                        window.localStorage.setItem('usertoken', response.data.token);

                        axios({
                            method: 'get',
                            url: themeConfig.apiurl + '/site/user/info',
                            params: {
                                token: response.data.token,
                            },
                            headers: {
                                Authorization: 'Bearer ' + response.data.token
                            }
                        })
                        .then(function (res) {
                            if(res.status == 200){                  
                                let user = {
                                    id: res.data.id,
                                    name: res.data.name,
                                    usertoken: response.data.token,
                                    userType: res.data.type_user,
                                    istherapistmanager: res.data.istherapistmanager,
                                    isSpaDirector: res.data.is_spa_director,
                                    login_date: moment().format('YYYY-MM-DD HH-mm-ss'),
                                    hotel: res.data.hotel,
                                };                        
                                                                                           
                                window.localStorage.setItem('userSession', JSON.stringify(user));
                                
                                that.$store.dispatch('addLoginUserDetails',
                                {
                                    'id' : res.data.id , 
                                    'name' : res.data.name ,
                                });

                                that.$router.push('/marcar');  
                            }    
                        })
                        .catch( function (err){
                            that.flag_login = true;
                            console.log(err);
                        });                                        
                    })
                    .catch(function (error){
                        that.flag_login = true;
                        that.badCredentialsMessage = error.response.data.error;
                        that.badCredentials = true;
                    })
                    .then(function (response) {
                        that.$vs.loading.close();
                    });
                }
            })
        },

        validateLoginInput() {
            return false;
        },
    },
    created() {
        if(window.localStorage.getItem('userSession') !== null){
            this.$router.push('/marcar');
            return;
        }
        window.addEventListener('keydown', (e) => {
            if(this.$route.name == 'pageLogin'){
                if (e.key == 'Enter') {
                    this.toLogin(document.getElementById("user-input").value, document.getElementById("pass-input").value);
                }
            }
            
        });
    }
}
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
